import { Component, computed, inject, signal } from "@angular/core"
import { RouterLink } from "@angular/router"
import { IntroService } from "../intro.service"
import { RouteService } from "../../../../services/route.service"
import { faAngleLeft, faAngleRight } from "@fortawesome/free-solid-svg-icons"
import { UiDialogComponent } from "ui-dialog"
import { NgOptimizedImage } from "@angular/common"
import { PageToolbarService } from "../../../page-toolbar.service"
import { UiIconComponent } from "ui-icon"
import { UiInheritDirective } from "ui-inherit"
import { StorageService } from "../../../../services/storage.service"

@Component({
  imports: [
    RouterLink,
    UiIconComponent,
    UiInheritDirective,
    UiDialogComponent,
    NgOptimizedImage,
  ],
  standalone: true,
  template: `
    @if (!!card()) {
      <lib-ui-dialog (cancelAndClose)="onClose()" position="top" [offset]="pageToolbarHeight() + 10">
        <div ngProjectAs="title">
          {{ card()?.title }}
        </div>

        <div ngProjectAs="content">

          @if (card(); as data) {
            <div 
              class="row justify-between text-xl font-black px-0 py-2"
            >
              <button
                class="btn btn-sm btn-accent"
                [routerLink]="[]"
                [fragment]="'legacy-for-today-' + data.type.previous.toLowerCase()"
                (click)="$event.preventDefault()"
              >
                <lib-ui-icon [icon]="faAngleLeft"/>
                {{ data.type.previous }}
              </button>
              <button
                class="btn btn-sm btn-accent"
                [routerLink]="[]"
                [fragment]="'legacy-for-today-' + data.type.next.toLowerCase()"
                (click)="$event.preventDefault()"
              >
                {{ data.type.next }}
                <lib-ui-icon [icon]="faAngleRight"/>
              </button>
            </div>

            <div class="float-right ml-5 mr-0 my-5 w-[250px]">
                  <img
                    #Image
                    [ngSrc]="imageSrc()"
                    [alt]="data.image.altText"
                    style="position: relative"
                    class="rounded-2xl"
                    fill
                  >
            </div>

            <div style="padding: 10px">
              @for (copyItem of data.copyArray; track copyItem.value) {
                @if (copyItem.type === 'paragraph') {
                  <div>
                    {{ copyItem.value }}
                  </div>
                }
              }
            </div>
          }
        </div>
      </lib-ui-dialog>
    }
  `,
  selector: "e2e-legacy-cards-modal",
})
export class LegacyCardsModalComponent {
  private routeService = inject(RouteService)
  private introService = inject(IntroService)
  private pageToolbarService = inject(PageToolbarService)
  private storageService = inject(StorageService)

  pageToolbarHeight = this.pageToolbarService.pageToolbarHeight

  fragments = this.introService.fragments
  hover = signal(false)
  cards = this.introService.cards
  card = computed(() =>
    this.cards().find(
      (card) => "legacy-for-today-" + card.type.current.toLowerCase() === this.fragments()[0]?.toLowerCase(),
    ),
  )
  imageSrc = computed(() =>
    this.storageService.getFileUrl(this.card()?.image.src)
  )

  onClose() {
    this.routeService.changeRoute([])
  }

  protected readonly faAngleLeft = faAngleLeft
  protected readonly faAngleRight = faAngleRight
}
